const mutations = {
    saveUserId(state, msg){
        state.userid = msg;
        try{
            if(localStorage){
                localStorage.setItem("userid",msg)
            }
        }catch(e){
            console.log(e,'异常')
        }
    },
    updateLoadingStatus(state,msg){
        state.isLoading = msg.isLoading
    },
    updateSchool(state, msg){
        state.school = msg.school
        try{
            if(localStorage){
                localStorage.setItem("school",msg.school)
            }
        }catch(e){
            console.log(e,'异常')
        }
    }
  }

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js